import "../styles/Header.css"
import { useTranslation } from "../i18n";
import SoundPlayer from "./SoundPlayer/SoundPlayer";

const Header = ({navbarToggle, navbarMenu, handleToggle, setNavbarToggle, setNavbarMenu}) => {
    const { lang, toggleLang } = useTranslation();
    return (
      <header className="header">
        <nav className="navbar">
      <div className="navbar-container">
        <a href="/" className="navbar-logo">
          <svg
            className="mixordia-logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 4431.55 1011.52"
          >
            <g>
              <g>
                <path
                  id="mxd-logo-o"
                  className="cls-1"
                  pathLength="100"
                  d="M2225.61,334.31h-2.77c-192.12,0-342.62,148.73-342.62,338.61s150.5,338.61,342.62,338.61h2.77c192.14,0,342.64-148.73,342.64-338.61s-150.5-338.61-342.64-338.61ZM1960.9,725.48c-29.01,0-52.56-23.54-52.56-52.57s23.54-52.57,52.56-52.57,52.56,23.54,52.56,52.57-23.52,52.57-52.56,52.57ZM2380.34,769.27c-33.77,54.66-91.61,87.3-154.72,87.3h-2.36c-81.38,0-153.17-52.34-174.59-127.28-17.02-59.71-6.47-120.88,28.95-167.82,34.61-45.88,87.54-72.2,145.23-72.2h3.16c68.36,0,131.3,37.52,160.33,95.59,30.67,61.38,28.48,128.6-6,184.41ZM2540.52,672.91c0,29.03-23.54,52.57-52.56,52.57s-52.56-23.54-52.56-52.57,23.52-52.57,52.56-52.57,52.56,23.54,52.56,52.57Z"
                />
                <path
                  id="mxd-logo-r"
                  className="cls-1"
                  pathLength="100"
                  d="M3371.65,0l-.02,334.31h.03v32.44c0,24.2,19.61,43.81,43.8,43.81h.73c35.58,0,66.32,28.85,64.58,64.39-1.54,31.45-26.77,56.67-58.21,58.2-35.52,1.73-64.34-29.02-64.34-64.6v-50.53c0-43.56-35.3-78.87-78.85-78.87h-82.61c-72.18,0-142.65,23.77-200.4,67.29v-65.23h-126.79c-152.25,0-275.68,123.46-275.68,275.75v387.35h146.72v-387.34c0-71.85,57.86-130.3,128.96-130.3h50.3c-42.6,63.27-62.24,139.45-55.46,216.4,14.46,164.58,170.14,303.63,339.97,303.63h326.08s-.02-1006.69-.02-1006.69h-158.78ZM3382.91,702.84c-11.29,74.8-68.12,136.18-141.43,152.72-59.47,13.46-118.4-2.6-163.87-45.07-30.54-28.52-51.06-67.04-57.2-108.37-17.23-116.12,70.44-216.43,180.56-216.43,53.24,0,103.81,23.3,138.76,63.92,35.84,41.67,51.58,97.52,43.18,153.23Z"
                />
                <path
                  id="mxd-logo-x"
                  className="cls-1"
                  pathLength="100"
                  d="M2009.97,339.14h-206.73l-152.39,181.97c-7.05,8.42-4.45,20.73,4.9,26.48,21.14,12.99,33.8,38.42,27.71,66.14-4.92,22.36-22.95,40.61-45.26,45.74-40.16,9.22-75.84-21.05-75.84-59.66,0-23.05,12.75-42.99,31.56-53.41,9.45-5.23,11.06-18.28,4.09-26.54l-152.5-180.71h-212.39s284.4,332.39,284.4,332.39l-284.3,335.16h206.68l180.95-216.94,180.97,216.94h212.27s-285.68-337.98-285.68-337.98l281.56-329.56Z"
                />
                <path
                  id="mxd-logo-a"
                  className="cls-1"
                  pathLength="100"
                  d="M4155.87,341.2h-317.19v131.96h317.2c71.1,0,128.96,71.94,128.96,143.8v9.71c0,15.06,8.45,28.7,21.74,35.78,19.98,10.63,32.27,33.71,26.28,59.03-4.43,18.73-19.67,33.9-38.42,38.26-34.51,8.03-65.17-17.96-65.17-51.1,0-15.41,6.65-29.2,17.23-38.76,13.7-12.38,18.72-34.17,9.08-49.92-45.76-74.68-129.18-124.37-217.74-124.37-138.18,0-254.91,115.59-254.91,252.41s114.35,256.31,254.91,256.31c112.69,0,211.74-75.41,243.17-184.22h3.83v184.22h146.72v-387.42c0-152.25-123.43-275.68-275.68-275.68ZM4036.53,860.13c-59.67,0-108.21-50.31-108.21-112.14,0-56.98,50.57-106.95,108.21-106.95s110.82,48.98,110.82,106.95c0,62.88-48.67,112.14-110.82,112.14Z"
                />
                <path id="mxd-logo-i-left" className="cls-1" pathLength="100" d="M1044.62,339.14H1204.44V1006.68H1044.62Z" />
                <path id="mxd-logo-i-left-dot" className="cls-1" pathLength="100" d="M1044.62,149.82H1204.44V309.7H1044.62Z" />
                <path id="mxd-logo-i-right" className="cls-1" pathLength="100" d="M3583.45,339.14H3743.27V1006.68H3583.45Z" />
                <path id="mxd-logo-i-right-dot" className="cls-1" pathLength="100" d="M3583.45,149.82H3743.27V309.7H3583.45Z" />
                <path
                  id="mxd-logo-m"
                  className="cls-1"
                  pathLength="100"
                  d="M705.36,339.14c-78.1,0-153.32,31.76-207.86,87.44-54.28-54.91-123.13-87.44-199.67-87.44-13.82,0-48.32,1.53-83.89,13.15-31.99,10.45-53.21,40.92-53.21,74.58l-.46,49.54c-2.66,35.72-35.52,63.03-73.34,55.57-22.9-4.51-41.84-22.66-47.12-45.39-9.32-40.16,20.8-75.8,59.28-76v-.03h13.04c19.4,0,35.1-15.76,35.04-35.16l-.12-36.25H0v667.55h159.87v-384.97c0-69.29,58.24-125.66,129.83-125.66s127.27,56.37,127.27,125.66v384.97h161.16v-388.42c1.11-68.53,57-122.21,127.23-122.21s126.31,53.63,128.53,121.82v388.8h159.87v-389.02c-1.44-153.58-130.81-278.52-288.4-278.52Z"
                />
              </g>
            </g>
          </svg>
        </a>
        <SoundPlayer />
        <button
          aria-label="Abrir menu"
          onClick={() => {handleToggle(setNavbarMenu);
                          handleToggle(setNavbarToggle);
        }} className={`navbar-toggle ${navbarToggle ? 'active' : ''}`}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
        <ul className={`navbar-menu ${navbarMenu ? 'active' : ''}`}>
          {}
          <li className="social-link">
            <a
              href="https://soundcloud.com/mixordiamusic"
              target="_blank"
              rel="noreferrer"
              className="social-link"
            >
              <svg
                className="soundcloud-logo"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 97.774 97.774"
              >
                <g>
                  <g>
                    <g>
                      <path
                        d="M4.723,49.69c-0.209,0-0.38,0.166-0.407,0.395l-0.961,8.781l0.961,8.586c0.027,0.229,0.198,0.396,0.407,0.396
				c0.206,0,0.373-0.164,0.406-0.395l1.094-8.588l-1.094-8.781C5.096,49.851,4.929,49.69,4.723,49.69z"
                      />
                      <path
                        d="M1.108,53.054c-0.203,0-0.365,0.156-0.392,0.383L0,58.866l0.716,5.337c0.026,0.226,0.188,0.382,0.392,0.382
				c0.198,0,0.359-0.156,0.391-0.38l0.847-5.339l-0.847-5.434C1.467,53.21,1.306,53.054,1.108,53.054z"
                      />
                      <path
                        d="M8.564,47.968c-0.258,0-0.464,0.202-0.49,0.48L7.161,58.866l0.913,10.037c0.026,0.279,0.232,0.48,0.49,0.48
				c0.253,0,0.459-0.201,0.489-0.479l1.036-10.039L9.053,48.447C9.023,48.17,8.817,47.968,8.564,47.968z"
                      />
                      <path
                        d="M12.437,47.6c-0.304,0-0.551,0.242-0.575,0.564L11,58.869l0.862,10.354c0.024,0.32,0.271,0.563,0.575,0.563
				c0.299,0,0.545-0.243,0.573-0.563l0.979-10.354L13.01,48.162C12.982,47.842,12.736,47.6,12.437,47.6z"
                      />
                      <polygon
                        points="16.996,69.31 16.996,69.31 16.996,69.312 			"
                      />
                      <path
                        d="M16.996,48.935c-0.024-0.365-0.308-0.644-0.656-0.644c-0.353,0-0.635,0.278-0.657,0.647l-0.814,9.93l0.814,10.441
				c0.022,0.367,0.305,0.646,0.657,0.646c0.349,0,0.632-0.279,0.656-0.646l0.923-10.441L16.996,48.935z"
                      />
                      <path
                        d="M20.276,41.985c-0.396,0-0.72,0.322-0.74,0.733l-0.764,16.155l0.764,10.44c0.021,0.406,0.345,0.729,0.74,0.729
				c0.392,0,0.716-0.322,0.74-0.732v0.004l0.864-10.44l-0.864-16.156C20.991,42.307,20.667,41.985,20.276,41.985z"
                      />
                      <path
                        d="M24.181,38.264c-0.443,0-0.804,0.358-0.824,0.815c0,0.002-0.715,19.85-0.715,19.85l0.716,10.375
				c0.02,0.455,0.38,0.813,0.823,0.813c0.44,0,0.804-0.358,0.823-0.815v0.006l0.809-10.379l-0.809-19.85
				C24.985,38.622,24.621,38.264,24.181,38.264z"
                      />
                      <path
                        d="M28.241,36.47c-0.491,0-0.89,0.396-0.907,0.9c0,0.001-0.665,21.508-0.665,21.508l0.665,10.268
				c0.018,0.5,0.416,0.895,0.907,0.895c0.488,0,0.887-0.395,0.907-0.898v0.006l0.751-10.27L29.148,37.37
				C29.127,36.866,28.729,36.47,28.241,36.47z"
                      />
                      <path
                        d="M33.26,36.647c-0.017-0.552-0.452-0.985-0.989-0.985c-0.541,0-0.976,0.434-0.991,0.985l-0.616,22.231l0.617,10.204
				c0.015,0.546,0.449,0.978,0.99,0.978c0.537,0,0.973-0.432,0.989-0.981l0.694-10.198L33.26,36.647z"
                      />
                      <polygon
                        points="33.26,69.078 33.26,69.078 33.26,69.083 			"
                      />
                      <path
                        d="M36.332,36.149c-0.59,0-1.061,0.469-1.075,1.068l-0.566,21.665l0.568,10.105c0.013,0.593,0.483,1.064,1.073,1.064
				c0.586,0,1.057-0.472,1.073-1.07v0.008l0.638-10.109l-0.638-21.666C37.389,36.616,36.918,36.149,36.332,36.149z"
                      />
                      <path
                        d="M40.425,36.856c-0.636,0-1.146,0.507-1.158,1.153L38.75,58.882l0.517,10.045c0.012,0.64,0.522,1.145,1.158,1.145
				c0.635,0,1.144-0.505,1.156-1.152v0.008l0.58-10.043l-0.58-20.875C41.569,37.363,41.06,36.856,40.425,36.856z"
                      />
                      <path
                        d="M45.235,33.02c-0.196-0.133-0.433-0.211-0.686-0.211c-0.246,0-0.475,0.075-0.668,0.201
				c-0.339,0.221-0.566,0.602-0.572,1.036l-0.004,0.234l-0.466,24.598c0,0.014,0.47,9.984,0.47,9.984
				c0,0.016,0.002,0.027,0.003,0.042c0.014,0.278,0.119,0.534,0.288,0.737c0.229,0.273,0.57,0.449,0.949,0.449
				c0.337,0,0.644-0.139,0.868-0.363c0.225-0.223,0.367-0.531,0.373-0.873l0.052-0.986l0.471-8.984l-0.522-24.839
				C45.783,33.618,45.563,33.242,45.235,33.02z"
                      />
                      <polygon
                        points="45.79,68.862 45.79,68.859 45.79,68.863 45.79,68.858 45.79,68.854 45.79,68.854 45.79,68.859 			"
                      />
                      <path
                        d="M49.329,30.665c-0.196-0.12-0.428-0.19-0.673-0.19c-0.316,0-0.607,0.114-0.836,0.302
				c-0.294,0.243-0.484,0.609-0.49,1.019l-0.003,0.136l-0.54,26.956l0.276,4.982l0.267,4.85c0.011,0.717,0.604,1.311,1.326,1.311
				c0.719,0,1.312-0.594,1.322-1.32v0.01v0.002l0.59-9.834l0,0L49.98,31.794C49.973,31.315,49.711,30.896,49.329,30.665z"
                      />
                      <path
                        d="M85.748,46.063c-1.646,0-3.22,0.334-4.65,0.933c-0.959-10.837-10.047-19.339-21.133-19.339
				c-2.714,0-5.357,0.534-7.693,1.437c-0.907,0.352-1.147,0.712-1.156,1.414c0,0.001,0,38.168,0,38.168
				c0.009,0.735,0.579,1.308,1.298,1.379c0.031,0.004,33.336,0,33.336,0c6.642,0,12.025-5.324,12.025-11.967
				C97.774,51.447,92.391,46.063,85.748,46.063z"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          </li>

          <li className="social-link">
            <a
              href="https://www.instagram.com/mixordiamusic"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
                className="instagram-logo"
              >
                <path
                  d="M20.445 5h-8.891A6.559 6.559 0 0 0 5 11.554v8.891A6.559 6.559 0 0 0 11.554 27h8.891a6.56 6.56 0 0 0 6.554-6.555v-8.891A6.557 6.557 0 0 0 20.445 5zm4.342 15.445a4.343 4.343 0 0 1-4.342 4.342h-8.891a4.341 4.341 0 0 1-4.341-4.342v-8.891a4.34 4.34 0 0 1 4.341-4.341h8.891a4.342 4.342 0 0 1 4.341 4.341l.001 8.891z"
                />
                <path
                  d="M16 10.312c-3.138 0-5.688 2.551-5.688 5.688s2.551 5.688 5.688 5.688 5.688-2.551 5.688-5.688-2.55-5.688-5.688-5.688zm0 9.163a3.475 3.475 0 1 1-.001-6.95 3.475 3.475 0 0 1 .001 6.95zM21.7 8.991a1.363 1.363 0 1 1-1.364 1.364c0-.752.51-1.364 1.364-1.364z"
                />
              </svg>
            </a>
          </li>
          <li>
            <a href="https://ra.co/events/2225504"
              target="_blank"
              rel="noreferrer"
              className="social-link">
              <svg
                className="ra-logo"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1100 1100"
              >
                <g>
                  <path
                    d="M708.967,539.159c3.131-2.982,5.109-7.161,5.109-11.825c0-4.489-2.136-8.524-5.062-11.478L577.22,384.062l-39.779,39.779
		l103.763,103.763H494.193c-7.186-0.215-12.882-2.626-17.7-7.296l-65.965-65.965c-6.84-6.468-16.211-10.561-26.37-10.561
		c-0.036,0-0.069,0.005-0.1,0.005v-0.005h-80.506v-27.526h83.378v0.005c16.52,0.008,31.259,6.769,42.063,17.62l49.203,49.203
		l39.779-39.779l-50.16-50.16C446.851,372.499,418.536,360,386.788,360c-0.034,0-0.069,0.002-0.103,0.002V360H247.294v140.039
		h117.977v0.009c7.673,0.055,14.601,3.21,19.603,8.279l64.604,64.606c6.571,6.454,15.45,10.522,25.295,10.888h178.464
		c7.513-0.098,14.298-3.175,19.25-8.112l36.508-36.504L708.967,539.159z"
                  />
                </g>
              </svg>
            </a>
          </li>
          <li>
            <button className="lang-toggle" onClick={toggleLang} aria-label="Toggle language">
              <span className={lang === "pt" ? "lang-active" : ""}>PT</span>
              <span className="lang-divider">|</span>
              <span className={lang === "en" ? "lang-active" : ""}>EN</span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
      </header>  
    )
}
export default Header
